import { createApp, h } from "vue";
import Bugsnag from "@bugsnag/js";
import BugsnagVue from "@bugsnag/plugin-vue";
import baseBugsnag from "@nextories/vue-core-components/src/utils/modules/bugsnag";
import ElementPlus from "element-plus";
import { ElLoading } from 'element-plus';
import nxtVue from '@nextories/vue-core-components';
import axios from './utils/modules/axios';
import './assets/scss/external/element-variables.scss';
import Api from './utils/api';
import MoverAPi from './utils/moverApi';
import './assets/scss/app.scss';
import helpers from './utils/helpers/index';
import App from './App.vue';
import i18nPlugin from './plugins/i18n';
import piniaPlugin from './plugins/pinia';
import router from './router';
import { mapActions } from 'pinia';
import { useAnalyticsStore } from './stores';
import components from "./components";

const app = createApp({
  methods: {
    ...mapActions(useAnalyticsStore, ['iniGtag'])
  },
  beforeMount() {
    // Initialize Google Analytics with page view tracking disabled
    this.iniGtag({
      send_page_view: false,
    });
  },
  render() {
    return h(App);
  },
});

// Configure error tracking with Bugsnag
baseBugsnag.config(import.meta.env.nxt);

// Install Nextories Vue core components if available
if (nxtVue?.install) {
  app.use(nxtVue.install);
}

Object.entries(components).forEach((entry) => {
  const name = `${entry[0]}`;
  entry[1].name = name;
  app.component(name, entry[1]);
});

app.use(i18nPlugin);
app.use(piniaPlugin);
app.use(router);

app.config.globalProperties.$loading = ElLoading.service;

// Setup API connectors
app.config.globalProperties.$API = axios(router, undefined);
// Main customer API endpoint
app.config.globalProperties.$APP_API = axios(router, undefined, import.meta.env.VITE_APP_API_CUSTOMER);
window.appConnector = new Api(app.config.globalProperties.$APP_API, true);

// Mover API endpoint with security key
app.config.globalProperties.$MOVER_API = axios(router, undefined, import.meta.env.VITE_APP_MOVER_API,
  import.meta.env.VITE_APP_MOVER_API_SECURITY_KEY);
window.moverappConnector = new MoverAPi(app.config.globalProperties.$MOVER_API, true);

// Disable Vue production tip in console
app.config.productionTip = false;

// Make helper functions globally available
Object.assign(app.config.globalProperties.$helpers, helpers);

// Mount the application to the DOM
router.isReady().then(() => app.mount('#app'));
